import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";

const TargetIrrSection = (props) => {
	const register = props.register;
	const isEditMode = props.isEditMode;
	const watch = props.watch;
	const setValue = props.setValue;
	const data = props.data;

	const january = watch("january_irr", data.january_irr);
	const february = watch("february_irr", data.february_irr);
	const march = watch("march_irr", data.march_irr);
	const april = watch("april_irr", data.april_irr);
	const may = watch("may_irr", data.may_irr);
	const june = watch("june_irr", data.june_irr);
	const july = watch("july_irr", data.july_irr);
	const august = watch("august_irr", data.august_irr);
	const september = watch("september_irr", data.september_irr);
	const october = watch("october_irr", data.october_irr);
	const november = watch("november_irr", data.november_irr);
	const december = watch("december_irr", data.december_irr);

	const [errors, setErrors] = useState({});

	/**
	 * Handle input change
	 * @param {event} evt
	 * @returns
	 */
	const handleChange = (evt, inputName) =>
		setValue(inputName, evt.target.value);

	useEffect(() => {
		const errorEntries = Object.entries(props.errors);
		const irrErrorEntries = errorEntries.map((entry) => {
			if (entry[0].includes("irr")) return entry;
			else return "";
		});

		const filteredUnused = irrErrorEntries.filter((entry) => entry !== "");

		setErrors(filteredUnused);
	}, [props.errors]);

	return (
		<>
			<hr />
			<h5>Irradiation (kWh/&#13217;)</h5>
			{errors.length > 0 && (
				<span className="required">
					*All Irradiation(kWh/&#13217;) fields required
				</span>
			)}
			<hr />
			<Row>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>January</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={january}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "january_irr")}
								name="january_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>February</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={february}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "february_irr")}
								name="february_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>March</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={march}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "march_irr")}
								name="march_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>April</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={april}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "april_irr")}
								name="april_irr"
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>May</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={may}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "may_irr")}
								name="may_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>June</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={june}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "june_irr")}
								name="june_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>July</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={july}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "july_irr")}
								name="july_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>August</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={august}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "august_irr")}
								name="august_irr"
							></input>
						</Col>
					</Row>
				</Col>
				<Col md="4">
					<Row>
						<Col md="3">
							<label>September</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={september}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "september_irr")}
								name="september_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>October</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={october}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "october_irr")}
								name="october_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>November</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={november}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "november_irr")}
								name="november_irr"
							></input>
						</Col>
					</Row>
					<Row>
						<Col md="3">
							<label>December</label>
						</Col>
						<Col md="7">
							<input
								type="number"
								step="0.01"
								min="0"
								ref={register}
								defaultValue={december}
								readOnly={!isEditMode}
								onChange={(evt) => handleChange(evt, "december_irr")}
								name="december_irr"
							></input>
						</Col>
					</Row>
				</Col>
			</Row>
		</>
	);
};

export default TargetIrrSection;
